import { withSearch } from '@elastic/react-search-ui';
import MultiChoiceAsyncSelect from '../../../components/filter/MultiChoiceAsyncSelect';

function ArchivePersonFilter({ addFilter, removeFilter, filters }) {
  return (
    <MultiChoiceAsyncSelect
      addFilter={addFilter}
      fieldId="person"
      filters={filters}
      id="person"
      label="Find records linked to specific individuals or institutions"
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, filters }) => ({
  addFilter,
  removeFilter,
  filters,
}))(ArchivePersonFilter);
